import React, { useState, useEffect } from 'react'
import ProjectPage from './ProjectPage';
import $ from 'jquery';
import Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

function ProjectSection() {

  const [resumeData, setResumeData] = useState({});
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    $.ajax({
      url:'/resumeData.json',
      dataType:'json',
      cache: false,
      success: function(data){
        setIsLoading(false);
        setResumeData(data);
      },
      error: function(xhr, status, err){
        console.log(err);
        alert(err);
      }
    });
  }, []);

  const loader = () => (
    <div className="loader">
      <Loader type="Circles" color="#EB5D2B" height={80} width={80}  />
    </div>
  );

  return (
    isLoading ? (loader()) : (
    <div className="ProjectSection">
      <ProjectPage data={resumeData.portfolio} />
    </div>)
  )
}

export default ProjectSection;
